export const EVENT_FOCUS: string = "focus";
export const EVENT_BLUR: string = "blur";
export const EVENT_INPUT: string = "input";
export const EVENT_CHANGE: string = "change";
export const EVENT_ANIMATION_START: string = "animationstart";



// WEBPACK FOOTER //
// ../common/material/form/form-event.ts